<template>
  <li :class="{ current: active }">
    <router-link :to="{ name: 'BookingInventoryProduct' }"
      ><i class="fa fa-cubes"></i> Inventory</router-link
    >
  </li>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>
